module.exports = __webpack_public_path__ + "static/media/Nauru.43ca2239.png";